import React from 'react'
import ScrollToTop from '../../ScrollToTop'

const Contact = () => {
    return (
        <div className="mb-20">
            <ScrollToTop />
            <div className="w-full h-40 flex justify-center items-center" style={{ background: '#f6f6f6' }}>
                <h1 className="text-4xl text-blk-txt">Contact Us</h1>
            </div>
            <div className="grid grid-cols-1  w-full md:grid-cols-2 md:gap-5 mt-12 ">
                <div className="mx-4" data-aos="fade-left">
                    <h1 className="text-2xl font-medium text-blk-txt">  Contact Information</h1>
                    <p className="text-sm text-ash py-2"> Vestibulum volutpat, lacus a ultrices sagittis, mi neque euismod dui, eu pulvinar nunc sapien ornare nisl. Phasellus pede arcu, dapibus eu, fermentum et, dapibus sed, urna.</p>
                    <div className="grid grid-cols-2 gap-6 py-3">
                        <div>
                            <h2 className="text-blk-ash text-xl py-2">The Office</h2>
                            <div className="flex items-center py-2">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-7 w-7 mr-3 text-primary-txt" viewBox="0 0 20 20" fill="currentColor">
                                    <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                                </svg>
                                <p className="text-ash text-sm"> 70 Washington Square South New York, NY 10012, United States</p>
                            </div>
                            <div className="flex items-center py-2">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-primary-txt mr-3" viewBox="0 0 20 20" fill="currentColor">
                                    <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                                </svg>
                                <p className="text-ash text-sm"> +92 423 567</p>
                            </div>
                            <div className="flex items-center py-2">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-primary-txt mr-3" viewBox="0 0 20 20" fill="currentColor">
                                    <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                                    <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                                </svg>
                                <p className="text-ash text-sm">info@Molla.com</p>
                            </div>
                        </div>
                        <div>
                            <h2 className="text-blk-ash text-xl py-2">
                                The Office
                            </h2>
                            <div className="flex items-center py-2">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-primary-txt mr-3" viewBox="0 0 20 20" fill="currentColor">
                                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                                </svg>
                                <p className="text-ash text-sm">Monday-Saturday
                                    11am-7pm ET</p>
                            </div>
                            <div className="flex items-center py-2">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-primary-txt mr-3" viewBox="0 0 20 20" fill="currentColor">
                                    <path fillRule="evenodd" d="M5 3a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V5a2 2 0 00-2-2H5zm9 4a1 1 0 10-2 0v6a1 1 0 102 0V7zm-3 2a1 1 0 10-2 0v4a1 1 0 102 0V9zm-3 3a1 1 0 10-2 0v1a1 1 0 102 0v-1z" clipRule="evenodd" />
                                </svg>
                                <p className="text-ash text-sm">Sunday
                                    11am-6pm ET</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div className="px-2" data-aos="fade-right">
                    <h1 className="text-2xl font-medium text-blk-txt">Got Any Questions?</h1>
                    <p className="text-sm text-ash py-2"> Use the form below to get in touch with the sales team</p>
                    <form>
                        <div className="w-full grid grid-cols-2 my-2 gap-2">
                            <input type="text" className="border bg-formclr shadow-sm outline-white px-2 text-sm py-2 rounded" name="" placeholder="Name *" id="" required />
                            <input type="email" className="border bg-formclr shadow-sm outline-white px-2 text-sm py-2 rounded" name="" placeholder="Email *" id="" required />
                        </div>
                        <div className="w-full grid grid-cols-2 my-2 gap-2">
                            <input type="number" className="border bg-formclr shadow-sm outline-white px-2 text-sm py-2 rounded" placeholder="Phone *" name="" id="" required />
                            <input type="text" className="border bg-formclr shadow-sm outline-white px-2 text-sm py-2 rounded" placeholder="Subject *" name="" id="" required />
                        </div>
                        <div className="my-2">
                            <textarea name="" className="w-full px-2 py-1 bg-formclr shadow-sm outline-white text-sm border rounded" placeholder="Message *" id="" cols="30" rows="10" required></textarea>
                        </div>
                        <input type="submit" value="Submit" className="bg-primary-txt transition delay-100 ease-in-out py-1 text-white hover:bg-new px-6" />
                        
                    </form>
                </div>
            </div>
        </div>
    )
}

export default Contact
